module.exports = __webpack_public_path__ + "static/antivol3-fcff49e85a1d00161105dbb57b91782a.jpg";